"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var SportsGolf = function SportsGolf(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M17.9338 6.62406C19.3731 6.29323 18.6534 4.96992 18.6534 4.96992L16.7712 4.74937C15.8855 4.6391 15.6641 5.24561 15.6641 5.24561L14.1141 9.38095L13.5051 9.54637L13.1176 2.43358C13.1176 1.66165 12.564 1.4411 12.564 1.4411L10.6819 1C9.0765 1.49624 10.4604 2.81955 10.4604 2.81955L12.2319 2.92982L12.4533 9.65664L11.3462 9.98747L9.18721 4.30827C8.96578 3.75689 8.46756 3.81203 8.46756 3.81203L6.47468 3.92231C5.14609 5.13534 7.02826 5.74185 7.02826 5.74185L8.57828 5.24561L10.5158 10.0977C9.24257 10.208 9.18721 11.0351 9.18721 11.0351C7.08361 11.7519 7.08361 15.2256 7.08361 15.2256C7.08361 18.589 9.13186 20.2982 9.13186 20.2982V22.0627C9.13186 22.7794 10.1837 23 10.1837 23H15.0552C16.3837 23 16.2177 21.6767 16.2177 21.6767H17.3248C18.0998 21.6216 17.9891 20.9048 17.9891 20.9048V16.6591C17.9891 15.9424 17.3248 15.8872 17.3248 15.8872L16.273 15.9424V13.1855C17.3802 13.2406 17.3802 12.4687 17.3802 12.4687L17.3248 10.3734C17.2695 9.6015 16.2177 9.87719 16.2177 9.87719C16.107 8.99499 15.2766 8.99499 15.2766 8.99499L16.6052 6.07268L17.9338 6.62406ZM9.02114 18.589C7.13897 14.1228 9.02114 12.3584 9.02114 12.3584V18.589Z",
    fill: "#75767A"
  }, colorStyles)));
};
SportsGolf.propTypes = _inline_svg2.default.propTypes;
SportsGolf.defaultProps = _inline_svg2.default.defaultProps;
var _default = SportsGolf;
exports.default = _default;